import * as React from "react";
import { Paper, Typography, Grid } from "@material-ui/core";
import { theme } from "../../theme/theme";

export const ErrorForm = (props) => {    
    return (
        <div className={props.classes.box}>
            <Grid container={true} spacing={16}>
                <Grid item={true} sm={12}>
                    <Paper style={{ background: theme.palette.error.main }}>
                        <Typography variant="body1" style={{color: "white", padding: theme.spacing.unit * 2}}>
                            {props.message}
                        </Typography>
                    </Paper>
                </Grid>
            </Grid>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/components/ErrorForm/ErrorForm.tsx